import Navbar from '../components/Navbar/Navbar'

import Footer from '../components/Footer/Footer'
import GreenworksIntro from '../components/About/GreenworksIntro'
import Book from '../components/About/Book'
import WhatWeDo from '../components/About/WhatWeDo'
import Aboutdetails from '../components/About/Aboutdetails'


const Aboutpage = () => {
    return (
        <div>
            <Navbar />
            <GreenworksIntro/>
            <Book/>
            <WhatWeDo/>
            <Aboutdetails/>

    
           
    
      
           
            <Footer/>
        </div>
    )
}

export default Aboutpage